// Lightweight analytics event bus. Pushes to window.dataLayer when present;
// otherwise no-ops (no PII collected). Wire a real provider in one place later.
export function track(event, payload = {}) {
  if (typeof window === "undefined") return;
  const entry = { event, ...payload, ts: Date.now() };
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(entry);
  if (process.env.NODE_ENV !== "production") console.debug("[analytics]", entry);
}

export const EVENTS = {
  CTA_CLICK: "cta_click",
  FORM_START: "form_start",
  FORM_SUBMIT: "form_submit",
  FORM_ERROR: "form_error",
  RESUME_SUBMIT: "resume_submit",
  STAFFING_REQUEST: "staffing_request",
  SERVICE_INTERACTION: "service_interaction",
  INDUSTRY_VIEW: "industry_view",
  CASE_STUDY_VIEW: "case_study_view",
  SEARCH: "search",
};
